import { render, staticRenderFns } from "./SpreadDetail.vue?vue&type=template&id=7557e7f3&scoped=true&"
import script from "./SpreadDetail.vue?vue&type=script&lang=js&"
export * from "./SpreadDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7557e7f3",
  null
  
)

export default component.exports